/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import {
  checkPolicyPage,
  getApiUrl,
  isAuthenticated,
} from "../../../utils/AuthUtils"; // Import the apiUrl  function
import { TSLogoDark, DefaultCompanyLogo } from "../../../Routes/ImagePath";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { useDispatch } from "react-redux";
import { login } from "../../../user";
import axios from "axios";
import Footer from "../../layout/Footer";
import ButtonLoader from "../../../components/ButtonLoader";
import Roles from "../Administration/Roles/Roles";
import CameraPopup from "../../../components/CameraPopup";
import Alert from "../../../components/Alert";
import { getOrCreateDeviceId } from "../../../utils/DeviceId";
// import { login } from "../../../user";

const validationSchema = Yup.object().shape({
  username: Yup.string()
    .test(
      "is-email-or-phone",
      "Enter a valid email or phone number",
      (value) => {
        if (!value) return false;
        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        const isPhone = /^[0-9]{10}$/.test(value);
        return isEmail || isPhone;
      }
    )
    .required("Either email or phone number is required"),
  password: Yup.string()
    .trim()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password must be at most 20 characters"),
});

const Login = () => {
  const details = localStorage.getItem("loginDetails");
  const [userData, setUserData] = useState({});
  const [faceuserData, setFaceuserData] = useState({});
  const [sessionId, setSessionId] = useState(null);

  const [usernameType, setUsernameType] = useState("Email or Mobile");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [startCamera, setStartCamera] = useState(false);
  const [faceAuthenticationError, setFaceAuthenticationError] = useState(false);
  const [faceAuthenticationSuccess, setFaceAuthenticationSuccess] =
    useState(false);
  const [faceImageBlob, setFaceImageBlob] = useState(null);
  const policyPage = checkPolicyPage();

  const loginData = JSON.parse(details);

  const {
    control,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const [entityLogo, setEntityLogo] = useState(TSLogoDark);
  const [entityName, setEntityName] = useState(false);
  const username = watch("username");

  // Device-registration notice: hidden by default (fail closed - don't
  // nag with a false positive if the check fails or hasn't resolved yet),
  // shown only once the backend confirms this device isn't registered.
  // Deliberately a fresh, uncached call straight to /api/validate-domain
  // rather than the AuthUtils.validateDomain() helper the app router uses
  // for its own domain check - that helper caches its result in
  // localStorage with a TTL, which would let a stale "registered" answer
  // survive a device actually being deregistered until the cache expires
  // or the user happens to clear it. device_registered is only present in
  // the response when device_id is sent (see user.controller.js's
  // validateDomain), so other validate-domain callers are unaffected.
  const [deviceUnregistered, setDeviceUnregistered] = useState(false);
  useEffect(() => {
    axios
      .get(`${getApiUrl()}/api/validate-domain`, {
        params: { device_id: getOrCreateDeviceId() },
      })
      .then(({ data }) => setDeviceUnregistered(data?.device_registered === false))
      .catch(() => setDeviceUnregistered(false));
  }, []);

  useEffect(() => {
    if (username) {
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(username)) {
        setUsernameType("Email Address");
      } else if (/^[0-9]{10}$/.test(username)) {
        setUsernameType("Mobile Number");
      } else {
        setUsernameType("Email or Mobile Number");
      }
    } else {
      setUsernameType("Email or Mobile Number");
    }
  }, [username]);

  const onSubmit = (data) => {
    setLoading(true);
    axios
      .post(getApiUrl() + "/api/login", {
        username: data.username.trim(),
        password: data.password,
        type: usernameType === "Mobile Number" ? "mobile" : "email",
      })
      .then(function (response) {
        setLoading(false);
        if (response.status === 200) {
          const success = response.data.success;
          if (success === 1) {
            const userData = response.data.data;
            const token = response.data.token;
            const role = response.data.role;
            const modules = response.data.modules;
            const categories = response.data.categories;
            let roleDefault = "/dashboard";
            if (["super-admin", "sales-head", "sales-rep"].includes(role)) {
              const categorySlug = categories?.[0]?.category_slug;
              if (categorySlug) {
                roleDefault = `/role-dashboard/${categorySlug}`;
              }
            }
            
            if (policyPage) {
              roleDefault = "/";
            }

            let redirectPath = location.state?.from?.pathname || roleDefault;
            if (role === "vendor") {
              redirectPath = "/employees-list";
            }
            setUserData(userData);
            localStorage.setItem("userData", JSON.stringify(userData));
            localStorage.setItem("categoryData", JSON.stringify(categories));
            localStorage.setItem(
              "userModulePermissions",
              JSON.stringify(modules)
            );
            localStorage.setItem("loginUrl", "/login");
            localStorage.setItem("token", token);
            localStorage.setItem("role", role);
            localStorage.setItem("colorschema", "blue");
            localStorage.setItem("layout", "vertical");
            localStorage.setItem("layoutwidth", "fluid");
            localStorage.setItem("layoutpos", "fixed");
            localStorage.setItem("topbartheme", "light");
            localStorage.setItem("layoutSized", "lg");
            localStorage.setItem("layoutStyling", "default");
            localStorage.setItem("layoutSidebarStyle", "light");
            dispatch(login(userData));
            console.log('redirectPath', redirectPath)
            // const redirectPath = localStorage.getItem("redirect_path");            
            navigate(redirectPath);              
          } else {
            setLoginErrorMessage(response.data.data);
            setLoginError(true); // Email is not registered
            navigate("/login");
            setTimeout(() => {
              setLoginErrorMessage("");
              setLoginError(false);
            }, 10000);
          }
        }
      })
      .catch(function (error) {
        setLoading(false);
        let errorMessage = "Unable to connect at the moment, please try again.";
        if (error.response?.data?.errors) {
          errorMessage = error.response.data.errors;
        }
        setLoginErrorMessage(errorMessage);
        setLoginError(true); // Email is not registered
        setTimeout(() => {
          setLoginErrorMessage("");
          setLoginError(false);
        }, 10000);
        navigate("/login");
      });
  };

  const handleCapture = async (imageData) => {
    const newSessionId = uuidv4();
    setSessionId(newSessionId); // store session ID
    setStartCamera(false);      // close the modal
  
    // Pass sessionId to submitFaceLogin
    await submitFaceLogin(imageData, newSessionId);
  };

  const authenticateFace = async (imageBlob, currentSessionId) => {
    try {
      const formData = new FormData();
      formData.append("image", imageBlob);
  
      const response = await axios.post(
        `${process.env.REACT_APP_FACE_AUTH_URL}/api/authenticate`,
        formData,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_FACE_AUTH_KEY,
            // Do NOT set 'Content-Type' – axios will set it automatically for FormData
          },
        }
      );
  
      if (response.data?.user) {
        const user = { ...response.data.user, sessionId: currentSessionId };
        setFaceuserData(user);
        setFaceAuthenticationSuccess(true);
        return user;
      } else {
        setFaceAuthenticationError(true);
        return null;
      }

    } catch (error) {
      console.error("Error in face verification", error);
      setFaceAuthenticationError(true);
      return false;
    }
  };
  
  const submitFaceLogin = async (imageData = null, currentSessionId = null) => {

    if (!imageData || !currentSessionId) return;
  
    setSubmitting(true);
  
    try {
      const imageBlob = await fetch(imageData).then((res) => res.blob());
  
      // Store in state (optional if you need later)
      setFaceImageBlob(imageBlob);
  
      // Send to backend for face match
      const authUser = await authenticateFace(imageBlob, currentSessionId); // pass sessionId  

      // SAFETY CHECK to avoid mismatched login
      if (!authUser ) {
        console.warn("Face authentication failed or session mismatch.");
        setSubmitting(false);
        setFaceAuthenticationError(true);
        return;
      }    
      // Login via face-identified user
      const response = await axios.post(getApiUrl() + `/api/face-login`, {
        email: authUser?.email || "",
        mobile: authUser?.mobile || "",
      });
  
      if (response?.status === 200 && response.data.success === 1) {
        const { data, token, role, modules, categories } = response.data;
  
        let roleDefault = "/dashboard";
        if (["super-admin", "sales-head", "sales-rep"].includes(role) && categories?.length > 0) {
          roleDefault = `/role-dashboard/${categories[0].category_slug}`;
        }
        if (policyPage) roleDefault = "/";
  
        const redirectPath = location.state?.from?.pathname || roleDefault;
        if (role === "vendor") {
          redirectPath = "/employees-list";
        }
        setUserData(data);
        localStorage.setItem("userData", JSON.stringify(data));
        localStorage.setItem("categoryData", JSON.stringify(categories));
        localStorage.setItem("userModulePermissions", JSON.stringify(modules));
        localStorage.setItem("loginUrl", "/login");
        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        localStorage.setItem("colorschema", "blue");
        localStorage.setItem("layout", "vertical");
        localStorage.setItem("layoutwidth", "fluid");
        localStorage.setItem("layoutpos", "fixed");
        localStorage.setItem("topbartheme", "light");
        localStorage.setItem("layoutSized", "lg");
        localStorage.setItem("layoutStyling", "default");
        localStorage.setItem("layoutSidebarStyle", "light");
  
        dispatch(login(data));
        setFaceAuthenticationSuccess(true);
        navigate(redirectPath);
      } else {
        setLoginErrorMessage('Face login Failed. Invalid User credentials');
        setLoginError(true);
        setTimeout(() => setLoginError(false), 10000);
      }
    } catch (error) {
      console.error("Face login error", error);
      setLoginError(true);
      setLoginErrorMessage("Something went wrong while logging in with face.");
    } finally {
      setSubmitting(false);
      setFaceImageBlob(null);
      setFaceuserData(null);
      setSessionId(null); // clear session ID
    }
  };
  
  const updatedEntityData = () => {
    if (
      localStorage.getItem("entity_name") &&
      localStorage.getItem("entity_name") !== "undefined"
    ) {
      setEntityLogo(localStorage.getItem("entity_logo"));
      setEntityName(localStorage.getItem("entity_name"));
    }
    let roleDefault = "/dashboard";
    if (
      ["super-admin", "sales-head", "sales-rep"].includes(
        localStorage.getItem("role")
      )
    ) {
      const categories = JSON.parse(localStorage.getItem("categoryData"));
      if (categories && categories.length > 0) {
        const categorySlug = categories[0].category_slug;
        roleDefault = "/role-dashboard/" + categorySlug;
      }
    }
    if (policyPage) {
      roleDefault = "/";
    }
    if (isAuthenticated()) {
      let redirectPath = location.state?.from?.pathname || roleDefault;
      if (localStorage.getItem("role") === "vendor") {
        redirectPath = "/employees-list";
      }
      return navigate(redirectPath);
    }
    setTimeout(() => {
      if (!entityName) {
        updatedEntityData();
      }
    }, 100);
  };

  useEffect(() => {
    if (!entityName) {
      updatedEntityData();
    }
  }, []);

  const [eye, seteye] = useState(true);

  const onEyeClick = () => {
    seteye(!eye);
  };

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            {/* <Link to="/job-list" className="btn btn-primary apply-btn">
              Apply Job
            </Link> */}
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <img
                  src={entityLogo}
                  alt="Company Logo"
                  onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop in case the default image also fails
                    e.target.src = DefaultCompanyLogo; // Set the default image on error
                  }}
                />
              </div>
              {/* /Account Logo */}
              <div className="account-box">
                <div className="account-wrapper">
                  <h2 className="account-title">
                    {entityName && (
                      <h2 className="account-title">{entityName}</h2>
                    )}
                  </h2>
                  {/* <h3 className="account-title">Login</h3> */}
                  <p className="account-subtitle">Access to our dashboard</p>
                  {/* Facility clock-in requires a registered device - GPS is
                      no longer a fallback (Phase 2 of the device-registration
                      rollout). Checked against /api/device-status (tenant
                      resolved from the subdomain, no session token needed
                      yet) so this only shows on a device that's actually
                      unregistered - most employees never see the
                      dashboard's own prompt, since only branch SPOCs get
                      that one. */}
                  {deviceUnregistered && (
                    <div className="alert alert-danger py-2 mb-3" role="alert" style={{ fontSize: "13px" }}>
                      This device is not registered for facility clock-in, so clock-in and
                      clock-out will not work from it. Please ask your facility SPOC or
                      tenant admin to register it by logging into their own account.
                    </div>
                  )}
                  {/* Account Form */}
                  <div>
                    {loginError === true && (
                      <div className="alert alert-danger" role="alert">
                        {loginErrorMessage}
                      </div>
                    )}

                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-block mb-4">
                        <label className="col-form-label">{usernameType}</label>
                        <Controller
                          name="username"
                          control={control}
                          render={({ field }) => (
                            <input
                              className={`form-control ${
                                errors?.username ? "error-input" : ""
                              }`}
                              type="text"
                              maxLength={
                                usernameType === "Mobile Number" ? 10 : 255
                              }
                              id="login_username"
                              onChange={field.onChange}
                              value={field.value}
                              autoComplete="true"
                            />
                          )}
                        />

                        <span className="text-danger">
                          {" "}
                          {errors.username?.message}{" "}
                        </span>
                      </div>
                      <div className="input-block mb-4">
                        <div className="row">
                          <div className="col">
                            <label className="col-form-label">Password</label>
                          </div>
                          <div className="col-auto">
                            {!policyPage && (
                              <Link
                                className="text-muted"
                                to="/forgot-password"
                              >
                                Forgot password?
                              </Link>
                            )}
                          </div>
                        </div>
                        <div style={{ position: "relative" }}>
                          <Controller
                            name="password"
                            control={control}
                            render={({ field }) => (
                              <input
                                className={`form-control ${
                                  errors?.password ? "error-input" : ""
                                }`}
                                id="login_password"
                                type={eye ? "password" : "text"}
                                value={field.value}
                                onChange={field.onChange}
                                // autoComplete="true"
                              />
                            )}
                          />
                          <span
                            style={{
                              position: "absolute",
                              right: "5%",
                              top: "30%",
                            }}
                            onClick={onEyeClick}
                            className={`fa-solid ${
                              eye ? "fa-eye-slash" : "fa-eye"
                            } `}
                          />
                        </div>
                        <span className="text-danger">
                          {" "}
                          {errors.password?.message}{" "}
                        </span>
                      </div>
                      <div className="input-block text-center">
                        <button
                          className="btn btn-primary account-btn"
                          type="submit"
                          id="login_btn"
                          disabled={loading}
                        >
                          {!loading ? `Login` : <ButtonLoader />}
                        </button>
                      </div>
                    </form>
                    <div className="d-flex align-items-center w-100 mb-4">
                      <hr className="flex-grow-1" />
                      <span className="mx-2 text-muted">OR</span>
                      <hr className="flex-grow-1" />
                    </div>
                    <div className="input-block text-center">
                      <button
                        className="btn btn-primary account-btn"
                        onClick={() => setStartCamera(true)}
                        id="login_btn_face"
                        disabled={loading}
                      >
                        {!loading ? `Login with Face` : <ButtonLoader />}
                      </button>
                    </div>
                    {faceAuthenticationError && (
                      <>
                        <div className="col-sm-12 mb-3">
                          <Alert
                            message={`Face Authentication Failed.`}
                            type="danger"
                            close="true"
                          />
                        </div>
                      </>
                    )}
                    {faceAuthenticationSuccess && (
                      <>
                        <div className="col-sm-12 mb-3">
                          <Alert
                            message={`Face authentication successful.`}
                            type="success"
                            close="true"
                          />
                        </div>
                      </>
                    )}
                    {startCamera && (
                      <CameraPopup
                        closeModal={() => setStartCamera(false)}
                        onCapture={handleCapture}
                        source="face-login"
                      />
                    )}
                    <div className="account-footer">
                      {/* <p>
                        Don't have an account yet?{" "}
                        <Link to="/register">Register</Link>
                      </p> */}
                    </div>
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
